import Api from './baseApi';

export default {
    searchPoolOrder: (Order) => {
        let url = "/api/poolOrders?v=1";
        if (Order.search)
            url += `&q=${Order.search}`;
        if (Order.state > -1)
            url += `&state=${Order.state}`;
        if (Order.startDate)
            url += `&startDate=${Order.startDate}`;
        if (Order.endDate)
            url += `&endDate=${Order.endDate}`;
        return Api.get(url)
    },
    getOrders: () => Api.get('/api/poolOrders'),
    getOrder: (id) => Api.get(`/api/poolOrders/${id}`),
    putOrder: (Order) => Api.put(`/api/poolOrders/${Order.id}`, Order),
    deleteOrder: (Order) => Api.delete(`/api/poolOrders/${Order.id}`, Order),
    postOrder: (Order) => Api.post(`/api/poolOrders`, Order),
    postBulkOrder: (Order) => {
        let url = `/api/poolOrders/bulkInsert`;
        return Api.post(url, Order);
    },
    markShippedByOrder: (orderId) => Api.post(`/api/poolOrders/MarkShippedByOrder/${orderId}`),
    bulkDelete: (Model) => Api.delete(`/api/poolOrders/bulkDelete`, {
        data: Model
    })
}